import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es una dieta difícil de seguir?',
  a: 'No, son comidas reales y placenteras adaptadas al gusto latino. No pasarás hambre ni tendrás que contar calorías obsesivamente.'
}, {
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, todo se basa en especias y alimentos que encuentras en cualquier supermercado como Walmart, Aldi o Target.'
}, {
  q: '¿Puedo hacerlo si trabajo fuera de casa?',
  a: 'Sí, está diseñado específicamente para la vida ocupada de una madre en USA, con opciones rápidas y fáciles de preparar.'
}, {
  q: '¿Es seguro si estoy amamantando?',
  a: 'El protocolo es a base de comida real y natural, pero siempre recomendamos consultar con tu pediatra antes de hacer cambios en tu alimentación.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-base" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-42">
          <h2 className="font-heading text-3xl md:text-4xl text-primary mb-4" data-id="element-43">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-sage overflow-hidden" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-46">
                <span className="font-bold text-ink text-lg pr-4" data-id="element-47">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-primary transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-50">
                    <div className="px-6 pb-6 text-ink/70 leading-relaxed border-t border-sage pt-4" data-id="element-51">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}